
const headerDrawerTabAnimations = new WeakMap();

function activateHeaderDrawerTab(menu, button, animate = false) {
  const tabList = menu.querySelector('.mobile-menu__main-categories');
  if (!tabList || !button) return;

  const buttons = Array.from(menu.querySelectorAll('.tab-button[data-tab-button-id]'));
  const panels = Array.from(menu.querySelectorAll('.tab-content[data-tab-content-id]'));
  const previousButton = buttons.find((tab) => tab.classList.contains('active'));
  const previousPanel = panels.find((panel) => panel.classList.contains('active'));
  const id = button.dataset.tabButtonId;
  const nextPanel = panels.find((panel) => panel.dataset.tabContentId === id);

  // Vorherigen Übergang bei schnellen Tabwechseln abbrechen.
  const previousAnimation = headerDrawerTabAnimations.get(menu);
  if (previousAnimation) {
    previousAnimation.out.cancel();
    previousAnimation.in?.cancel();
    headerDrawerTabAnimations.delete(menu);
  }

  // Tabbar und blauen Indikator sofort aktualisieren.
  buttons.forEach((tab) => {
    const active = tab.dataset.tabButtonId === id;
    tab.classList.toggle('active', active);
    tab.classList.toggle('menu-drawer__menu-item--active', active);
    tab.setAttribute('aria-selected', String(active));
  });

  const index = Array.from(tabList.children).indexOf(button.closest('li'));

  if (index >= 0) {
    tabList.style.setProperty('--custom-tab-index', String(index));
  }

  tabList.setAttribute('data-custom-tabs-ready', '');

  const showNextPanel = () => {
    panels.forEach((panel) => {
      panel.classList.toggle('active', panel === nextPanel);
    });
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (
    !animate ||
    reduceMotion ||
    !previousPanel ||
    !nextPanel ||
    previousPanel === nextPanel
  ) {
    showNextPanel();
    return;
  }

  const previousIndex = buttons.indexOf(previousButton);
  const nextIndex = buttons.indexOf(button);
  const direction = nextIndex > previousIndex ? 1 : -1;
  const distance = 16;

  // Alten Inhalt leicht herausbewegen und ausblenden.
  const out = previousPanel.animate(
    [
      { opacity: 1, transform: 'translateX(0)' },
      { opacity: 0, transform: `translateX(${-direction * distance}px)` }
    ],
    {
      duration: 140,
      easing: 'ease-in',
      fill: 'forwards'
    }
  );

  const state = { out, in: null };
  headerDrawerTabAnimations.set(menu, state);

  out.finished.then(() => {
    if (headerDrawerTabAnimations.get(menu) !== state) return;

    showNextPanel();
    out.cancel();

    // Neuen Inhalt von der Gegenseite einblenden.
    state.in = nextPanel.animate(
      [
        {
          opacity: 0,
          transform: `translateX(${direction * distance}px)`
        },
        {
          opacity: 1,
          transform: 'translateX(0)'
        }
      ],
      {
        duration: 210,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
      }
    );

    return state.in.finished;
  }).then(() => {
    if (headerDrawerTabAnimations.get(menu) === state) {
      headerDrawerTabAnimations.delete(menu);
    }
  }).catch(() => {
    // Abgebrochene Animationen bei schnellen Wechseln sind normal.
  });
}

function initHeaderDrawerTabs(root = document) {
  root.querySelectorAll('.header-drawer .finkid-tab.tabmenu').forEach((menu) => {
    const active = menu.querySelector('.tab-button.active[data-tab-button-id]');
    const first = menu.querySelector('.tab-button[data-tab-button-id]');

    activateHeaderDrawerTab(menu, active || first);
  });
}

// Klicks zentral behandeln, auch nach einem Drawer-Re-Rendering.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(
    '.header-drawer .finkid-tab.tabmenu .tab-button[data-tab-button-id]'
  );

  if (!button) return;

  event.preventDefault();

  // Erneuter Klick auf den aktiven Tab: URL öffnen.
  if (button.classList.contains('active')) {
    const url = button.dataset.tabUrl?.trim();

    if (url && url !== '#') {
      window.location.assign(url);
    }

    return;
  }

  const menu = button.closest('.finkid-tab.tabmenu');

  if (menu) {
    activateHeaderDrawerTab(menu, button, true);
  }
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeaderDrawerTabs());
} else {
  initHeaderDrawerTabs();
}

document.addEventListener('shopify:section:load', (event) => {
  initHeaderDrawerTabs(event.target);
});
